import { ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Register custom --animate-* utilities so tailwind-merge resolves animation conflicts.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      animate: [
        "animate-loader",
        "animate-spinner-dash",
        "animate-accordion-down",
        "animate-accordion-up",
        "animate-pulse-3",
        "animate-pulse-4",
        "animate-pulse-5",
        "animate-slide",
        "animate-slide-item",
        "animate-scale-75",
        "animate-scale-80",
        "animate-scale-85",
        "animate-scale-90",
        "animate-fill-width",
        "animate-expand-typing-width",
        "animate-expand-typing-width-linear",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
